<template>
  <section
    id="pageMainContent"
    :class="['app-main', { 'app-main--natural-scroll': useNaturalScrollRoute }]"
    :style="appMainStyle"
  >
    <transition name="fade-transform" mode="out-in">
      <router-view :key="key" />
    </transition>
  </section>
</template>

<script>
export default {
  name: 'AppMain',
  computed: {
    key() {
      return this.$route.path;
    },
    useNaturalScrollRoute() {
      return ['/ai/revenue-manager', '/ai/store-manager-report'].includes(this.$route.path);
    },
    canBeDisplayedAtTheCurrentLink() {
      let arr = ['/tabpage'];
      console.log(this.$route.path, arr.indexOf(this.$route.path) == -1);
      return arr.indexOf(this.$route.path) == -1;
    },
    appMainStyle() {
      if (this.useNaturalScrollRoute) {
        return {
          height: 'auto',
          minHeight: this.canBeDisplayedAtTheCurrentLink ? 'calc(100vh - 98px)' : 'calc(100vh - 58px)',
        };
      }
      return {
        height: this.canBeDisplayedAtTheCurrentLink ? 'calc(100vh - 98px)' : 'calc(100vh - 58px)',
      };
    },
  },
};
</script>

<style scoped>
.app-main {
  /*50 = navbar  */
  height: calc(100vh - 98px);
  width: 100%;
  position: relative;
  overflow: auto;
  background-color: #f4f5f9;
}

.app-main--natural-scroll {
  overflow: visible;
}

/*.fixed-header+.app-main {*/
/*  padding-top: 50px;*/
/*}*/
</style>

<style lang="scss">
// fix css style bug in open el-dialog
.el-popup-parent--hidden {
  .fixed-header {
    // padding-right: 15px;
  }
}
</style>
